import gstyles from '@gstyles/index';
import { IconProps } from '@gstyles/styleguide/icons';
const View = ({ color, ...props }: IconProps) => {
  return gstyles.icons({
    color,
    ...props,
  });
};
export default View;
